<!--ng-container *ngIf="object?.errors">
  <ng-container *ngTemplateOutlet="
      formErrors;
      context: { errors: this.filterErrors([ERRORTYPE.EXCEPTION, ERRORTYPE.FATAL, ERRORTYPE.ERROR], object.errors) }
    "></ng-container>
  <ng-container *ngTemplateOutlet="
      formErrors;
      context: { errors: this.filterErrors([ERRORTYPE.WARNING], object.errors) }
    "></ng-container>
</ng-container>

<ng-template #formErrors let-filteredErrors="errors">
  <div *ngIf="filteredErrors" class="ui-message ui-messages-error ui-corner-all ng-star-inserted ">
    <formControlErrorMessage [errors]="filteredErrors"></formControlErrorMessage>
  </div>
</ng-template>
-->
<ng-container *ngIf="object?.errors">
  <ng-container
    *ngTemplateOutlet="
      formErrors;
      context: {
        errors: this.filterErrors(
          [ERRORTYPE.EXCEPTION, ERRORTYPE.FATAL],
          object.errors
        )
      }
    "
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="
      formErrors;
      context: { errors: this.filterErrors([ERRORTYPE.ERROR], object.errors) }
    "
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="
      formErrors;
      context: { errors: this.filterErrors([ERRORTYPE.WARNING], object.errors) }
    "
  ></ng-container>
</ng-container>

<ng-template #formErrors let-filteredErrors="errors">
  <div
    *ngIf="filteredErrors"
    class="ui-message ui-messages-error ui-corner-all ng-star-inserted "
  >
    <formControlErrorMessage
      [errors]="filteredErrors"
    ></formControlErrorMessage>
  </div>
</ng-template>
